import type { ComponentPropsWithRef } from "react";

export const AddKnowledgeIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g id="Group_97381" data-name="Group 97381" transform="translate(-2 -2)">
      <path
        id="Path_246867"
        data-name="Path 246867"
        d="M13,11h2.75a1,1,0,0,1,0,2H8.25a1,1,0,0,1,0-2H13Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        id="Path_246871"
        data-name="Path 246871"
        d="M10.75,11a1,1,0,0,1,0,2H8.25a1,1,0,0,1,0-2Z"
        transform="translate(0 4)"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        id="Path_246870"
        data-name="Path 246870"
        d="M13,11h2.75a1,1,0,0,1,0,2H8.25a1,1,0,0,1,0-2H13Z"
        transform="translate(0 -4)"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        id="Path_246868"
        data-name="Path 246868"
        d="M4,4V20H20V4ZM2,3.6A1.6,1.6,0,0,1,3.6,2H20.4A1.6,1.6,0,0,1,22,3.6V20.4A1.6,1.6,0,0,1,20.4,22H3.6A1.6,1.6,0,0,1,2,20.4Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
